/**
 * Translations for the home feature area.
 * Covers HomePage and CareerRankBadge.
 */
const home = {
  zh: {
    // ── Pet reaction lines (per topic, three variants each) ───────────────
    'home.reaction.tap.0': '：谢谢主人轻轻拍拍，我好安心呀～',
    'home.reaction.tap.1': '：主人来陪我啦，我超开心！',
    'home.reaction.tap.2': '：被主人摸到心里暖暖的～',
    'home.reaction.stroke.0': '：好舒服呀，谢谢主人摸摸我！',
    'home.reaction.stroke.1': '：舒服到想眯眼睛，谢谢主人～',
    'home.reaction.stroke.2': '：主人摸摸最治愈啦，我好喜欢！',
    'home.reaction.rub.0': '：和主人一起疯玩太开心啦！',
    'home.reaction.rub.1': '：谢谢主人陪我玩，我充满能量啦！',
    'home.reaction.rub.2': '：主人最好啦，我们再玩一会儿嘛～',
    'home.reaction.ball.0': '：谢谢主人丢球，我跑得超开心！',
    'home.reaction.ball.1': '：球球好好玩，主人再夸夸我嘛～',
    'home.reaction.ball.2': '：我把球带回来啦，谢谢主人陪我！',
    'home.reaction.swing.0': '：哇，秋千好好玩，谢谢主人！',
    'home.reaction.swing.1': '：像飞起来一样，主人太棒啦！',
    'home.reaction.swing.2': '：荡秋千好开心，我最喜欢主人陪我！',
    'home.reaction.water.0': '：洗澡澡好舒服，水花转起来啦！',
    'home.reaction.water.1': '：我洗得香香的，开心到想转圈圈～',
    'home.reaction.water.2': '：谢谢主人帮我洗澡，我要跳个小舞！',
    'home.reaction.butterfly.0': '：蝴蝶好漂亮，谢谢主人陪我看！',
    'home.reaction.butterfly.1': '：主人陪我发现小惊喜啦，好开心！',
    'home.reaction.butterfly.2': '：我们和蝴蝶做朋友吧，谢谢主人～',

    // ── Dialogue opener lines ─────────────────────────────────────────────
    'home.dialogue.tap.0': '你来啦！可以再摸摸我吗？',
    'home.dialogue.tap.1': '我好想和你靠近一点点～',
    'home.dialogue.tap.2': '轻轻拍我超安心的！',
    'home.dialogue.stroke.0': '你摸摸我，我感觉超幸福！',
    'home.dialogue.stroke.1': '我想一直贴着你～',
    'home.dialogue.stroke.2': '你在我就特别安心。',
    'home.dialogue.rub.0': '我们来个超能量冒险吧！',
    'home.dialogue.rub.1': '我还想继续玩，太开心啦！',
    'home.dialogue.rub.2': '快看我，今天状态满格！',
    'home.dialogue.ball.0': '球球再来一次好不好？',
    'home.dialogue.ball.1': '我刚刚跑得超快！',
    'home.dialogue.ball.2': '你丢球我来追，太有趣了！',
    'home.dialogue.swing.0': '秋千好好玩，再荡高一点点！',
    'home.dialogue.swing.1': '我好像在飞起来～',
    'home.dialogue.swing.2': '和你一起玩我最开心啦！',
    'home.dialogue.water.0': '洗澡澡好凉快呀～',
    'home.dialogue.water.1': '我把水珠都转起来啦！',
    'home.dialogue.water.2': '今天洗得干干净净，太快乐了。',
    'home.dialogue.butterfly.0': '蝴蝶好漂亮，我想和它打招呼！',
    'home.dialogue.butterfly.1': '我刚刚是不是很温柔？',
    'home.dialogue.butterfly.2': '我们可以一起追蝴蝶吗？',

    // ── Dialogue option labels & replies ──────────────────────────────────
    'home.opt.tap.praise.label': '你最乖',
    'home.opt.tap.praise.reply': '听到夸奖我更开心啦！',
    'home.opt.tap.hug.label': '抱抱你',
    'home.opt.tap.hug.reply': '抱抱好温暖～',
    'home.opt.tap.play.label': '继续玩',
    'home.opt.tap.play.reply': '好呀，我们继续！',
    'home.opt.stroke.love.label': '我爱你',
    'home.opt.stroke.love.reply': '我也最喜欢你！',
    'home.opt.stroke.snuggle.label': '贴贴',
    'home.opt.stroke.snuggle.reply': '贴贴最治愈了～',
    'home.opt.stroke.adventure.label': '去冒险',
    'home.opt.stroke.adventure.reply': '出发！我准备好了！',
    'home.opt.rub.cheer.label': '太棒啦',
    'home.opt.rub.cheer.reply': '被你夸我充满力量！',
    'home.opt.rub.quest.label': '来挑战',
    'home.opt.rub.quest.reply': '好耶！挑战我最在行！',
    'home.opt.rub.rest.label': '喝口水',
    'home.opt.rub.rest.reply': '补充能量再继续！',
    'home.opt.ball.throw.label': '再丢一次',
    'home.opt.ball.throw.reply': '来吧！我还能跑更快！',
    'home.opt.ball.wow.label': '你真快',
    'home.opt.ball.wow.reply': '嘿嘿，我超厉害吧！',
    'home.opt.ball.highfive.label': '击个掌',
    'home.opt.ball.highfive.reply': '啪！配合超默契！',
    'home.opt.swing.higher.label': '荡更高',
    'home.opt.swing.higher.reply': '哇！像在飞一样！',
    'home.opt.swing.sing.label': '一起唱歌',
    'home.opt.swing.sing.reply': '啦啦啦，和你唱歌真开心！',
    'home.opt.swing.pat.label': '拍拍你',
    'home.opt.swing.pat.reply': '谢谢你一直陪我玩～',
    'home.opt.water.splash.label': '来泼水',
    'home.opt.water.splash.reply': '哈哈，水花大战开始！',
    'home.opt.water.cool.label': '好凉快',
    'home.opt.water.cool.reply': '凉凉的好舒服呀！',
    'home.opt.water.dry.label': '擦一擦',
    'home.opt.water.dry.reply': '谢谢照顾我，我更喜欢你了！',
    'home.opt.butterfly.wave.label': '打招呼',
    'home.opt.butterfly.wave.reply': '嗨蝴蝶！我们是朋友！',
    'home.opt.butterfly.photo.label': '拍张照',
    'home.opt.butterfly.photo.reply': '咔嚓！这瞬间太美啦！',
    'home.opt.butterfly.follow.label': '跟着飞',
    'home.opt.butterfly.follow.reply': '我会轻轻追上它！',

    // ── Interaction missions ──────────────────────────────────────────────
    'home.mission.care.title': '今天想被温柔陪一会儿',
    'home.mission.care.desc': '{name} 想要 6 次轻拍、抚摸或聊聊天，慢一点也好。',
    'home.mission.play.title': '今天好想疯玩一场',
    'home.mission.play.desc': '{name} 想跟你玩 5 次，丢球、秋千、洗澡都行。',
    'home.mission.wonder.title': '想跟你一起看看小蝴蝶',
    'home.mission.wonder.desc': '{name} 想观察 4 次小蝴蝶，或跟你聊一聊看到的东西。',
    'home.todayLoop.aria': '今日陪伴流程',
    'home.todayLoop.care.title': '先陪一下',
    'home.todayLoop.care.desc': '轻拍、抚摸或聊天',
    'home.todayLoop.mission.title': '做今日互动',
    'home.todayLoop.mission.desc': '完成小任务拿奖励',
    'home.todayLoop.mission.ready': '有奖励可以领取',
    'home.todayLoop.games.title': '玩一个小游戏',
    'home.todayLoop.games.desc': '按年龄推荐可玩内容',
    'home.todayLoop.progress': '今日陪伴 {done}/{total}',
    'home.companionHeat.label': '陪伴热度',
    'home.companionHeat.warm': '手感不错，继续陪它',
    'home.companionHeat.hot': '状态很好，连起来玩',
    'home.thought.aria': '宠物想法',
    'home.thought.missionReady': '{name}：今天的奖励可以领啦！',
    'home.thought.hungry': '{name}：肚肚有点饿，可以吃点东西吗？',
    'home.thought.care': '{name}：可以摸摸我一下吗？',
    'home.thought.focusMission': '{name}：今天的小心愿想跟你一起完成～',
    'home.thought.games': '{name}：要不要玩一个小游戏？',
    'home.thought.chat': '{name}：我有悄悄话想跟你说。',
    'home.thought.time.morning': '{name}：早安呀，今天阳光好棒～',
    'home.thought.time.noon': '{name}：中午要不要陪我歇会儿？',
    'home.thought.time.afternoon': '{name}：下午想看看我吗？',
    'home.thought.time.evening': '{name}：今天过得怎么样？说给我听呀',
    'home.thought.time.late': '{name}：困了……我们一起休息一下吧',
    'home.thought.sceneMatch.water': '{name}：这片水真舒服～',
    'home.thought.sceneMiss.water': '{name}：我有点想念水边……',
    'home.thought.scene.blossom': '{name}：花瓣飘下来啦，好香～',
    'home.thought.scene.autumn': '{name}：你看，叶子都变红啦',
    'home.thought.scene.night': '{name}：夜空好安静，一起看星星吗？',
    'home.thought.scene.magicalForest': '{name}：这里好神秘，会有什么呢？',
    'home.thought.scene.cloudKingdom': '{name}：踩在云上软软的，飞起来啦～',
    'home.thought.persona.lively.0': '{name}：我蹦蹦跳跳好开心！',
    'home.thought.persona.lively.1': '{name}：等不及和你做下一件事啦！',
    'home.thought.persona.lively.2': '{name}：嘿嘿，今天还有什么好玩的？',
    'home.thought.persona.calm.0': '{name}：让我们慢慢享受这一刻吧',
    'home.thought.persona.calm.1': '{name}：在你身边就很舒服了',
    'home.thought.persona.calm.2': '{name}：嗯……睡个小午觉真舒服',
    'home.thought.persona.curious.0': '{name}：那边的东西是什么呀？',
    'home.thought.persona.curious.1': '{name}：让我闻闻新味道～',
    'home.thought.persona.curious.2': '{name}：我好像发现了一个小秘密！',
    'home.thought.persona.proud.0': '{name}：哼哼，今天我可是很神气的',
    'home.thought.persona.proud.1': '{name}：有你在，这片小天地最有趣',
    'home.thought.persona.proud.2': '{name}：看，我闪闪发光的样子',
    'home.thought.welcome.blossom': '{name}：哇！今天我们来花海啦～',
    'home.thought.welcome.beach': '{name}：耶！到海边了，去找贝壳吧',
    'home.thought.welcome.autumn': '{name}：哇！秋天的叶子在等我们呢',
    'home.thought.welcome.starry': '{name}：哇！今晚的星星好亮',
    'home.thought.welcome.magicalForest': '{name}：哇！神秘森林到啦，悄悄走',
    'home.thought.welcome.cloudKingdom': '{name}：哇！踩到云上啦，飞起来～',
    'home.thought.welcome.underwater': '{name}：哇！海底世界，要小心鱼群',
    'home.petDrawer.bar.hunger': '肚肚饱满度',
    'home.petDrawer.bar.happiness': '心情指数',
    'home.petDrawer.barsAria': '肚肚饱满 {hunger}%，心情 {happiness}%',
    'home.thought.bondHigh': '{name}：你是我最喜欢的小朋友',
    'home.thought.bondLow': '{name}：我们慢慢认识，好吗？',
    'home.thought.daydream': '{name}：我在想小小的心事呢',
    'home.thought.wonder': '{name}：那是什么呀？好想知道',

    // ── Scene prompts ─────────────────────────────────────────────────────
    'home.prompt.text.0': '{name} 想和你玩一个小互动，回应它吧～',
    'home.prompt.text.1': '{name} 盯着小球看了好久，要不要陪它？',
    'home.prompt.text.2': '{name} 发现一只蝴蝶，想和你一起看！',
    'home.prompt.opt.pat': '轻拍一下',
    'home.prompt.opt.hug': '摸摸它',
    'home.prompt.opt.play': '一起玩',
    'home.prompt.opt.ball': '丢球',
    'home.prompt.opt.swing': '去秋千',
    'home.prompt.opt.water': '去洗澡',
    'home.prompt.opt.butterfly': '追蝴蝶',
    'home.prompt.opt.talk': '聊两句',
    'home.prompt.opt.care': '摸摸再说',

    // ── Toasts / inline messages ──────────────────────────────────────────
    'home.toast.missionsRefreshed': '🌤 新的一天，互动任务已刷新',
    'home.toast.feedEmpty': '背包里没有食物了，去商店购买食物吧',
    'home.toast.feedNeedFood': '背包没有食物，提醒去商店补给',
    'home.toast.activeSwitched': '✨ {name} 现在是主互动宠物',
    'home.toast.switchedTo': '已切换到 {name}',
    'home.toast.challengeDone': '挑战完成！{net} ✨',
    'home.toast.feedEnjoy': '{name}：谢谢主人，{food} 太好吃啦！饱食 {hunger} · 快乐 {happiness}{bonus}',
    'home.toast.feedBonus': ' (物种加成✨)',
    'home.toast.feedThanks': '{name}：谢谢主人，太好吃啦！',
    'home.toast.feedThankNote': '{name} 感谢主人投喂 {food}',
    'home.appreciation.feed': '{name} 送你一个大大的爱心：谢谢主人喂我 {food}，我好幸福！',
    'home.toast.missionReward': '奖励到账 🤝+{bond} · 💖+{happy} · 📈+{exp}',

    // ── Activity log labels ───────────────────────────────────────────────
    'home.activity.tap': '👋 你轻拍了 {name}',
    'home.activity.stroke': '🫶 你抚摸了 {name}，它舒服地眯起眼睛',
    'home.activity.rub': '✨ 你和 {name} 疯玩了一会儿',
    'home.activity.ball': '🎾 {name} 追着小球跑了一圈',
    'home.activity.swing': '🎠 {name} 在秋千上晃来晃去',
    'home.activity.water': '🛁 {name} 洗澡后开心地转圈圈',
    'home.activity.butterfly': '🦋 一只蝴蝶停在 {name} 头上',
    'home.activity.dialogue': '对话互动：{label}',
    'home.activity.startTalk': '和 {name} 发起对话',
    'home.activity.missionDone': '任务完成：{title}',
    'home.activity.bottleHeard': '{name} 听到了主人的悄悄话',

    // ── Dialogue scene reactions ──────────────────────────────────────────
    'home.dialogue.replyText': '{name}{reply}',
    'home.dialogue.petLine': '{name}：{line}',
    'home.mission.complete': '{name} 完成「{title}」',

    // ── Errors ────────────────────────────────────────────────────────────
    'home.error.fallback': '出错了',
    'home.error.dialogueSync': '对话状态同步失败，已自动回拉最新状态',
    'home.error.interactionSync': '互动状态同步失败，已自动回拉最新状态',
    'home.error.missionClaim': '任务奖励领取失败，请稍后重试',

    // ── Empty / no-pet state ──────────────────────────────────────────────
    'home.empty.title': '你的动物乐园还在等第一位伙伴',
    'home.empty.hint': '最便宜的仓鼠 💰15。先做几道题 / 小任务赚点小金币，再来领养第一位乐园伙伴吧！',
    'home.empty.scene.alt': '默认草地场景，等小宠物来住',
    'home.empty.scene.caption': '这里会慢慢变成你的动物乐园',
    'home.empty.earn.quiz.title': '答题',
    'home.empty.earn.quiz.sub': '每题赚 💰50',
    'home.empty.earn.chores.title': '小任务',
    'home.empty.earn.chores.sub': '完成日常目标',
    'home.empty.earn.imagine.title': '想象',
    'home.empty.earn.imagine.sub': '写故事得奖励',
    'home.empty.earn.shop.title': '商店',
    'home.empty.earn.shop.sub': '钱够就去领养',
    'home.empty.goal': '👑 你的目标：成为最棒的动物乐园园长',

    // ── Play-gate banner ──────────────────────────────────────────────────
    'home.gate.pending': '⏳ 今天还有 {count} 个小任务要打卡',
    'home.gate.tail': ' — 完成后才能聊天和购物 👉',
    'home.gate.choreWithDeadline': '{title}（{hour}:00 前）',

    // ── Pet rail ──────────────────────────────────────────────────────────
    'home.rail.vibe.sad': '有点闷闷',
    'home.rail.vibe.hungry': '饿饿',
    'home.rail.vibe.good': '心情很好',
    'home.rail.activeSuffix': ' · 当前主宠物',
    'home.rail.manage': '管理',
    'home.rail.hiddenCount': '还有 {count} 只',
    'home.rail.manageAll': '全部 {count} 只',
    'home.rail.switch': '换一只',
    'home.rail.switch.count': '共 {count} 只小动物',
    'home.petDrawer.title': '选择宠物',
    'home.petDrawer.subtitle': '共 {count} 位动物伙伴，优先照顾需要你的那几只',
    'home.petDrawer.close': '关闭宠物选择',
    'home.petDrawer.filter.all': '全部',
    'home.petDrawer.filter.needs_care': '需要照顾',
    'home.petDrawer.filter.same_species': '同物种',
    'home.petDrawer.filter.happy': '状态很好',
    'home.petDrawer.sort.status': '按状态',
    'home.petDrawer.sort.species': '按物种',
    'home.petDrawer.sort.name': '按名字',
    'home.petDrawer.status.hungry': '饿了',
    'home.petDrawer.status.sad': '想被陪陪',
    'home.petDrawer.status.happy': '状态很好',
    'home.petDrawer.status.ok': '正常',
    'home.petDrawer.active': '当前',
    'home.petDrawer.empty': '这个筛选下暂时没有宠物',

    // ── Scene event / dispatch MVP ────────────────────────────────────────
    'home.sceneEvent.action': '探索',
    'home.sceneEvent.activity': '{name} 完成了「{title}」',
    'home.sceneEvent.meadow.title': '草地里有小脚印！',
    'home.sceneEvent.meadow.desc': '{name} 在草丛里发现了一串小脚印，想拉着你一起看看。',
    'home.sceneEvent.meadow.reaction': '{name} 跟着小脚印走了一圈，回头蹭了蹭你！',
    'home.sceneEvent.meadow.action': '一起去看看',
    'home.sceneEvent.aqua.title': '水边有什么在闪？',
    'home.sceneEvent.aqua.desc': '{name} 听见水声，好像看到了一颗小贝壳。',
    'home.sceneEvent.aqua.reaction': '{name} 找到一颗闪闪的小贝壳！',
    'home.sceneEvent.aqua.action': '凑近看看',
    'home.sceneEvent.aquaFit.title': '{name} 想下水散散步',
    'home.sceneEvent.aquaFit.desc': '{name} 今天能量特别好，想沿着水边走一圈。',
    'home.sceneEvent.aquaFit.reaction': '{name} 在水边巡游了一圈，像回到最舒服的家！',
    'home.sceneEvent.aquaFit.action': '陪它走一圈',
    'home.sceneEvent.blossom.title': '花瓣观察',
    'home.sceneEvent.blossom.desc': '{name} 想接住一片落下来的花瓣。',
    'home.sceneEvent.blossom.reaction': '{name} 接住花瓣，轻轻放到你手心里。',
    'home.sceneEvent.autumn.title': '落叶收集',
    'home.sceneEvent.autumn.desc': '{name} 想挑一片最好看的叶子做纪念。',
    'home.sceneEvent.autumn.reaction': '{name} 找到一片漂亮落叶，认真藏进小窝里。',
    'home.sceneEvent.night.title': '星光守夜',
    'home.sceneEvent.night.desc': '{name} 想和你一起数三颗最亮的星星。',
    'home.sceneEvent.night.reaction': '{name} 数完星星，安静地靠近你。',
    'home.sceneEvent.magic.title': '蘑菇寻踪',
    'home.sceneEvent.magic.desc': '{name} 发现发光的小蘑菇，想请你一起确认路线。',
    'home.sceneEvent.magic.reaction': '{name} 找到一条闪光小路，眼睛都亮起来了！',
    'home.sceneEvent.sky.title': '云朵巡逻',
    'home.sceneEvent.sky.desc': '{name} 想看看云边有没有彩虹。',
    'home.sceneEvent.sky.reaction': '{name} 看见云边彩虹，兴奋地转了一圈！',
    'home.dispatch.title': '宠物派遣',
    'home.dispatch.ready': '可领取',
    'home.dispatch.remaining': '剩 {seconds}s',
    'home.dispatch.inProgress': '进行中',
    'home.dispatch.claim': '领取故事',
    'home.dispatch.garden.title': '花园巡护',
    'home.dispatch.garden.desc': '{name} 去花园看看植物和小路。',
    'home.dispatch.coast.title': '海边探索',
    'home.dispatch.coast.desc': '{name} 去水边找贝壳和脚印。',
    'home.dispatch.library.title': '图书角学习',
    'home.dispatch.library.desc': '{name} 去图书角学一个新词。',
    'home.dispatch.patrol.title': '园区值班',
    'home.dispatch.patrol.desc': '{name} 巡一圈动物乐园，看看谁需要帮助。',
    'home.dispatch.toast.started': '{name} 出发去「{title}」了',
    'home.dispatch.reaction.start': '{name} 背上小包，出发去「{title}」！',
    'home.dispatch.reaction.done': '{name} 完成「{title}」，带回了一段小故事。',
    'home.dispatch.appreciation': '{name} 完成「{title}」后回来了：我学到新东西啦！',
    'home.dispatch.activity.done': '{name} 完成派遣：{title}',

    // ── Stage / scene picker ──────────────────────────────────────────────
    'home.stage.hint': '🎯 {hint}',
    'home.stage.changeScene': '🖼️ 换场景',
    'home.stage.mode3D': '🧊 3D 场景',
    'home.stage.mode2D': '🎨 2D 场景',
    'home.stage.noWebgl': '当前设备不支持 3D，已自动切换到 2D 场景。',
    'home.stage.challenge.spend': '花 {cost}',
    'home.stage.challenge.reward': '奖 +{reward}',
    'home.stage.challenge.process': '处理',

    // ── Feed FX / labels ──────────────────────────────────────────────────
    'home.feed.fxAria': '{name} 正在吃 {food}',
    'home.feed.tasty': '好吃！',

    // ── Equipment ─────────────────────────────────────────────────────────
    'home.equipment.title': '{name}（长按 3 秒后拖动摆放）',

    // ── Scene reaction meta ───────────────────────────────────────────────
    'home.scene.reactionMeta': '亲密度 +{bond} · 连击 x{combo}',
    'home.scene.replyHint': ' · 点我对话',
    'home.scene.replyOpening': '正在打开聊天窗口…',
    'home.scene.replyAria': '回复宠物反馈',

    // ── Scene prompt UI ───────────────────────────────────────────────────
    'home.scenePrompt.later.aria': '稍后再互动',
    'home.scenePrompt.later': '稍后',
    'home.scenePrompt.title': '🐾 互动邀请',
    'home.sceneDialog.close.aria': '关闭对话',
    'home.sceneDialog.title': '💬 互动对话',
    'home.sceneDialog.chatHint': '想多聊两句？可以直接去会话里回复它。',
    'home.sceneDialog.chatCta': '去会话',

    // ── Side panel ────────────────────────────────────────────────────────
    'home.side.actionsTitle': '一起玩',
    'home.action.tap': '轻拍',
    'home.action.stroke': '抚摸',
    'home.action.rub': '疯玩',
    'home.action.feed': '喂食',
    'home.action.feed.goBuy': '去买食物',
    'home.action.feed.bag': '背包 {count}',
    'home.action.ball': '🎾 丢球',
    'home.action.swing': '🎠 秋千',
    'home.action.water': '🛁 洗澡',
    'home.action.talk': '💬 对话',
    'home.action.bottle': '🍶 留言瓶',
	    // v0.12.0 — primary action row labels (single-char buttons under stage)
	    'home3.action.pet': '摸',
	    'home3.action.play': '玩',
	    'home3.action.chat': '聊',
	    'home3.console.aria': '今日陪伴小指南',
	    'home3.console.kicker': '今日小指南',
	    'home3.console.title': '{name} 的今日计划',
	    'home3.console.titleFallback': '今日陪伴计划',
	    'home3.console.map': '去动物乐园',
	    'home3.playSheet.title': '想怎么玩？',
	    'home3.playSheet.close': '关闭',

    'home.side.statusTitle': '宠物状态',
    'home.status.noData': '还没有情绪数据',
    'home.status.bestBuddy': '我们现在是最默契的伙伴！',
    'home.status.hungry': '我有点饿，想吃点好吃的',
    'home.status.lonely': '抱抱我，我想和你一起玩',
    'home.status.elated': '今天超开心，我们继续冒险吧',
    'home.status.normal': '状态不错，来点互动会更开心',
    'home.status.hunger': '🍗 饱食',
    'home.status.happy': '💖 快乐',
    'home.status.level': '📈 等级',
    'home.status.bond': '🤝 亲密',
    'home.status.bondLevel': '{level}级',

    'home.energy.title': '互动热度',
    'home.energy.hot': 'HOT!',
    'home.energy.combo': '连击中',
    'home.energy.start': '起步中',
    'home.activity.latest': '刚刚：{text}',

    // ── Right-panel section titles (v0.13.7) ─────────────────────────────
    'home.todayQuest.title': '今日任务',
    'home.progress.title': '成长进度',

    // ── Mission panel ─────────────────────────────────────────────────────
    'home.mission.panelTitle': '今日互动任务',
    'home.mission.badge.ready': '{count} 可领奖',
    'home.mission.badge.done': '{done}/{total} 已完成',
    'home.mission.reward': '奖励 🤝{bond} · 💖{happy} · 📈{exp}',
    'home.mission.claim.claiming': '领取中...',
    'home.mission.claim.ready': '领取',
    'home.mission.claim.done': '已领取',
    'home.mission.claim.progress': '进行中',

    // ── Main hint ─────────────────────────────────────────────────────────
    'home.hint.adopt': '去商店领养第一只小伙伴吧',
    'home.hint.missionsReady': '今日任务有 {count} 项可领奖励，记得领取',
    'home.hint.starving': '{name} 饿坏了，去商店买点吃的喂 ta',
    'home.hint.lowMood': '{name} 今天有点低落，多抚摸和玩球会更好',
    'home.hint.careerGap': '下一个惊喜：{unlock}！继续陪它玩就快啦～',
    'home.hint.noFood': '你背包里没食物了，记得去商店补货',
    'home.hint.tryDrag': '拖动抚摸宠物，点场景道具和蝴蝶都能触发互动',

    // ── Pet placeholder name ──────────────────────────────────────────────
    'home.pet.fallbackName': '小伙伴',

    // ── Feed modal ────────────────────────────────────────────────────────
    'home.feed.modalTitle': '🍗 喂 {name}',
    'home.feed.empty': '你背包里没食物了～',
    'home.feed.goShop': '去商店买',
    'home.feed.qty': '数量：{count}',
    'home.feed.do': '喂！',
    'home.feed.close': '关闭',

    // ── Scene picker ──────────────────────────────────────────────────────
    'home.scenePicker.title': '🖼️ 换场景',
    'home.scenePicker.hint': '拥有的场景才能选；去 商店 → 装饰 → 场景 买更多',
    'home.scenePicker.meadowAlt': '草地',
    'home.scenePicker.meadowLabel': '🌿 草地（默认）',
    'home.scenePicker.empty': '还没买过场景。\n去 商店 → 装饰 → 🖼️ 场景 看看吧～',
    'home.scenePicker.close': '关闭',

    // ── Career rank (used by CareerRankBadge) ─────────────────────────────
    'home.rank.unlock': '本级解锁：',
    'home.rank.hamster.state': '小仓鼠状态：',
    'home.rank.keeperLevel': '园长 Lv.{level}',
    'home.rank.keeperXp': '园长经验：',
    'home.rank.source.activeDays': '活跃',
    'home.rank.source.careDays': '照顾',
    'home.rank.source.animals': '动物',
    'home.rank.source.tasks': '任务',
    'home.rank.next.label': '下一级 Lv.{level} {emoji} {title}',
    'home.rank.next.reach': '还差 {money} 经验',
    'home.rank.next.gap': '距 Lv.{level} {title} 还差 {money} 经验',
    'home.rank.maxed': '满级啦！动物乐园由你掌管 ✨',

    // ── PWA update banner ─────────────────────────────────────────────────
    'home.update.reloading': '加载中...',

    // ── v0.12.0 Age-tier variants ─────────────────────────────────────────
    // Bare keys above are the default (young, 7-9). Tiered variants below
    // override per child age. i18n/index.ts t() tries `key.${tier}` first,
    // falls back to bare key if tier variant missing. Authors can add or
    // remove variants freely — partial coverage is fine.
    //
    // Tone guide:
    //   .little  3-6  super short, lots of "！" and emoji, baby words
    //   .older  10-12 fuller sentence, light wordplay, no baby talk
    //   .tween  13-14 peer-to-peer, dry humor okay, never sleazy

    // home.dialogue.tap.0 — pet's opening line when child taps
    'home.dialogue.tap.0.little': '主人摸摸我！再来！',
    'home.dialogue.tap.0.older':  '嘿，你回来啦，正想着你呢～',
    'home.dialogue.tap.0.tween':  '你可算来了，今天怎么样？',

    'home.dialogue.stroke.0.little': '抱抱！我喜欢～',
    'home.dialogue.stroke.0.older':  '你的手好温柔，我都困了。',
    'home.dialogue.stroke.0.tween':  '这种安静的时刻最舒服了。',

    'home.dialogue.rub.0.little': '玩玩玩！',
    'home.dialogue.rub.0.older':  '今天能量爆棚，咱们去冒险吧！',
    'home.dialogue.rub.0.tween':  '走起，今天必须把场子炸开。',

    'home.dialogue.ball.0.little': '球球！再丢！',
    'home.dialogue.ball.0.older':  '球再来一次嘛，我刚刚跑得超快！',
    'home.dialogue.ball.0.tween':  '再来一局？我刚那个起步是不是绝了。',

    // home.scenePrompt.title — banner when pet wants attention
    'home.scenePrompt.title.little': '🐾 一起玩玩！',
    'home.scenePrompt.title.older':  '🐾 来跟我互动一下嘛',
    'home.scenePrompt.title.tween':  '🐾 来唠唠？',

    // home.hint.tryDrag — first-run interaction hint
    'home.hint.tryDrag.little': '用手指摸摸我，点点小道具～',
    'home.hint.tryDrag.older':  '试试拖动抚摸宠物，点场景道具或蝴蝶都能触发互动',
    'home.hint.tryDrag.tween':  '拖动抚摸 / 点击道具与蝴蝶都会触发互动事件',

    // home.hint.starving — pet is hungry
    'home.hint.starving.little': '{name} 饿啦，去给 ta 找吃的！',
    'home.hint.starving.older':  '{name} 真的饿坏了，赶紧去商店买点东西',
    'home.hint.starving.tween':  '{name} 饥饿值告急，建议立刻补给',

    // home.hint.lowMood — pet is sad
    'home.hint.lowMood.little': '{name} 不开心了，快摸摸 ta！',
    'home.hint.lowMood.older':  '{name} 今天有点低落，多陪 ta 玩一会儿就好',
    'home.hint.lowMood.tween':  '{name} 状态有点 down，陪 ta 互动几下能恢复',
  } as Record<string, string>,

  en: {
    // ── Pet reaction lines ────────────────────────────────────────────────
    'home.reaction.tap.0': ': Thanks for the gentle pat — I feel so safe!',
    'home.reaction.tap.1': ': You came to play with me, I am so happy!',
    'home.reaction.tap.2': ': Your pat makes my heart all warm~',
    'home.reaction.stroke.0': ': So comfy, thanks for petting me!',
    'home.reaction.stroke.1': ': So nice I want to close my eyes, thank you!',
    'home.reaction.stroke.2': ': Your strokes heal me, I love them!',
    'home.reaction.rub.0': ': Romping with you is the best!',
    'home.reaction.rub.1': ': Thanks for playing — I am full of energy now!',
    'home.reaction.rub.2': ': You are the best, let us play a bit more~',
    'home.reaction.ball.0': ': Thanks for the throw, I had a blast running!',
    'home.reaction.ball.1': ': The ball is so fun, praise me again~',
    'home.reaction.ball.2': ': I brought it back, thanks for playing!',
    'home.reaction.swing.0': ': Wow the swing is so fun, thank you!',
    'home.reaction.swing.1': ': Like flying! You are the best!',
    'home.reaction.swing.2': ': Swinging is amazing, I love when you play with me!',
    'home.reaction.water.0': ': Bath time feels so fresh, the splashes are spinning!',
    'home.reaction.water.1': ': I smell clean and I want to twirl~',
    'home.reaction.water.2': ': Thanks for the bath, I am doing a happy dance!',
    'home.reaction.butterfly.0': ': The butterfly is pretty, thanks for watching with me!',
    'home.reaction.butterfly.1': ': You found a little surprise with me, so happy!',
    'home.reaction.butterfly.2': ': Let us be friends with the butterfly, thank you~',

    // ── Dialogue opener lines ─────────────────────────────────────────────
    'home.dialogue.tap.0': 'You came! Could you pat me again?',
    'home.dialogue.tap.1': 'I want to be just a little closer to you~',
    'home.dialogue.tap.2': 'Light pats make me feel so safe!',
    'home.dialogue.stroke.0': 'When you pet me I feel so happy!',
    'home.dialogue.stroke.1': 'I want to snuggle close forever~',
    'home.dialogue.stroke.2': 'When you are here I feel safe.',
    'home.dialogue.rub.0': 'Let us go on a super-energy adventure!',
    'home.dialogue.rub.1': 'I want to keep playing, this is so fun!',
    'home.dialogue.rub.2': 'Look at me, today I am full power!',
    'home.dialogue.ball.0': 'One more throw of the ball please?',
    'home.dialogue.ball.1': 'I just ran super fast!',
    'home.dialogue.ball.2': 'You throw, I chase — so fun!',
    'home.dialogue.swing.0': 'The swing is fun, push me higher!',
    'home.dialogue.swing.1': 'I feel like I am flying~',
    'home.dialogue.swing.2': 'Playing with you makes me happiest!',
    'home.dialogue.water.0': 'Bath time is so cool~',
    'home.dialogue.water.1': 'I spun all the droplets up!',
    'home.dialogue.water.2': 'I am clean and very happy today.',
    'home.dialogue.butterfly.0': 'The butterfly is pretty, I want to say hi!',
    'home.dialogue.butterfly.1': 'Was I gentle just now?',
    'home.dialogue.butterfly.2': 'Can we chase the butterfly together?',

    // ── Dialogue option labels & replies ──────────────────────────────────
    'home.opt.tap.praise.label': 'You are the best',
    'home.opt.tap.praise.reply': 'Praise makes me even happier!',
    'home.opt.tap.hug.label': 'Hug you',
    'home.opt.tap.hug.reply': 'Hugs are so warm~',
    'home.opt.tap.play.label': 'Keep playing',
    'home.opt.tap.play.reply': 'Yes! Let us keep going!',
    'home.opt.stroke.love.label': 'I love you',
    'home.opt.stroke.love.reply': 'I love you most too!',
    'home.opt.stroke.snuggle.label': 'Snuggle',
    'home.opt.stroke.snuggle.reply': 'Snuggles heal everything~',
    'home.opt.stroke.adventure.label': 'Go adventuring',
    'home.opt.stroke.adventure.reply': "Let's go! I'm ready!",
    'home.opt.rub.cheer.label': 'Awesome!',
    'home.opt.rub.cheer.reply': 'Your cheer fills me with power!',
    'home.opt.rub.quest.label': 'Take a challenge',
    'home.opt.rub.quest.reply': "Yay! I'm great at challenges!",
    'home.opt.rub.rest.label': 'Sip of water',
    'home.opt.rub.rest.reply': 'Refuel and keep going!',
    'home.opt.ball.throw.label': 'Throw again',
    'home.opt.ball.throw.reply': 'Yes! I can run even faster!',
    'home.opt.ball.wow.label': 'You are fast',
    'home.opt.ball.wow.reply': 'Hehe, I am pretty awesome!',
    'home.opt.ball.highfive.label': 'High five',
    'home.opt.ball.highfive.reply': 'Smack! Perfect teamwork!',
    'home.opt.swing.higher.label': 'Higher',
    'home.opt.swing.higher.reply': 'Wow! Like flying!',
    'home.opt.swing.sing.label': 'Sing along',
    'home.opt.swing.sing.reply': 'La-la-la, singing with you is fun!',
    'home.opt.swing.pat.label': 'Pat you',
    'home.opt.swing.pat.reply': 'Thanks for always playing with me~',
    'home.opt.water.splash.label': 'Splash!',
    'home.opt.water.splash.reply': 'Haha, splash war begins!',
    'home.opt.water.cool.label': 'So cool',
    'home.opt.water.cool.reply': 'Cool and refreshing!',
    'home.opt.water.dry.label': 'Dry off',
    'home.opt.water.dry.reply': 'Thanks for caring, I love you even more!',
    'home.opt.butterfly.wave.label': 'Say hi',
    'home.opt.butterfly.wave.reply': 'Hi butterfly! Friends!',
    'home.opt.butterfly.photo.label': 'Take a photo',
    'home.opt.butterfly.photo.reply': 'Click! What a moment!',
    'home.opt.butterfly.follow.label': 'Follow it',
    'home.opt.butterfly.follow.reply': 'I will follow softly!',

    // ── Interaction missions ──────────────────────────────────────────────
    'home.mission.care.title': '{name} wants gentle company today',
    'home.mission.care.desc': 'Pet, stroke, or chat with {name} 6 times. Take your time.',
    'home.mission.play.title': '{name} feels like going wild today',
    'home.mission.play.desc': 'Play with {name} 5 times — toss a ball, swing, or splash a bath.',
    'home.mission.wonder.title': "{name} wants to watch butterflies with you",
    'home.mission.wonder.desc': 'Spot a butterfly 4 times or chat about what you see together.',
    'home.todayLoop.aria': 'Today companion flow',
    'home.todayLoop.care.title': 'Start with care',
    'home.todayLoop.care.desc': 'Pat, pet, or chat',
    'home.todayLoop.mission.title': 'Do today’s loop',
    'home.todayLoop.mission.desc': 'Finish a small mission',
    'home.todayLoop.mission.ready': 'Reward ready to claim',
    'home.todayLoop.games.title': 'Play one mini-game',
    'home.todayLoop.games.desc': 'Age-fit games are ready',
    'home.todayLoop.progress': 'Today loop {done}/{total}',
    'home.companionHeat.label': 'Companion heat',
    'home.companionHeat.warm': 'Nice rhythm. Keep caring.',
    'home.companionHeat.hot': 'Great flow. Keep playing.',
    'home.thought.aria': 'Pet thought',
    'home.thought.missionReady': '{name}: Today’s reward is ready!',
    'home.thought.hungry': '{name}: My tummy is a little hungry. Can I eat?',
    'home.thought.care': '{name}: Could you pet me for a second?',
    'home.thought.focusMission': "{name}: Today's little wish — want to do it with me?",
    'home.thought.games': '{name}: Want to play a mini-game?',
    'home.thought.chat': '{name}: I have a tiny secret to tell you.',
    'home.thought.time.morning': '{name}: Good morning! The sun feels lovely.',
    'home.thought.time.noon': '{name}: Want to take a midday break with me?',
    'home.thought.time.afternoon': '{name}: Could we hang out for a bit this afternoon?',
    'home.thought.time.evening': '{name}: How was today? Tell me about it.',
    'home.thought.time.late': '{name}: Sleepy… let’s rest together.',
    'home.thought.sceneMatch.water': '{name}: This water feels so good.',
    'home.thought.sceneMiss.water': '{name}: I miss the water a little…',
    'home.thought.scene.blossom': '{name}: Petals are floating down — so fragrant!',
    'home.thought.scene.autumn': '{name}: Look, all the leaves turned red!',
    'home.thought.scene.night': '{name}: The night sky is so peaceful — watch the stars with me?',
    'home.thought.scene.magicalForest': '{name}: It feels so mysterious here — what could be hiding?',
    'home.thought.scene.cloudKingdom': '{name}: The clouds feel soft — I’m floating!',
    'home.thought.persona.lively.0': '{name}: I’m hopping around — so happy!',
    'home.thought.persona.lively.1': '{name}: Can’t wait for our next adventure!',
    'home.thought.persona.lively.2': '{name}: Hehe — what fun thing shall we do?',
    'home.thought.persona.calm.0': '{name}: Let’s just enjoy this quiet moment.',
    'home.thought.persona.calm.1': '{name}: I feel so cozy next to you.',
    'home.thought.persona.calm.2': '{name}: Mmm… a tiny nap sounds perfect.',
    'home.thought.persona.curious.0': '{name}: What’s that over there?',
    'home.thought.persona.curious.1': '{name}: Let me sniff this new thing!',
    'home.thought.persona.curious.2': '{name}: I think I just found a little secret!',
    'home.thought.persona.proud.0': '{name}: Hmph — I’m feeling rather magnificent today.',
    'home.thought.persona.proud.1': '{name}: With you here, this little world is the best.',
    'home.thought.persona.proud.2': '{name}: Look at me — I’m sparkling!',
    'home.thought.welcome.blossom': '{name}: Yay! We’re in the blossom field today~',
    'home.thought.welcome.beach': '{name}: Whee! At the beach — let’s look for shells!',
    'home.thought.welcome.autumn': '{name}: Wow! The autumn leaves are waiting for us.',
    'home.thought.welcome.starry': '{name}: Wow! The stars are extra bright tonight.',
    'home.thought.welcome.magicalForest': '{name}: Wow! Mystical forest — let’s tip-toe.',
    'home.thought.welcome.cloudKingdom': '{name}: Wow! On the clouds — we’re floating!',
    'home.thought.welcome.underwater': '{name}: Wow! Underwater — watch out for the fish!',
    'home.petDrawer.bar.hunger': 'Tummy fullness',
    'home.petDrawer.bar.happiness': 'Mood',
    'home.petDrawer.barsAria': 'Tummy {hunger}%, mood {happiness}%',
    'home.thought.bondHigh': '{name}: You’re my favorite friend.',
    'home.thought.bondLow': '{name}: Let’s get to know each other slowly.',
    'home.thought.daydream': '{name}: I’m daydreaming about something small.',
    'home.thought.wonder': '{name}: What is that? I want to know!',

    // ── Scene prompts ─────────────────────────────────────────────────────
    'home.prompt.text.0': '{name} wants to play a little — answer back~',
    'home.prompt.text.1': '{name} is staring at the ball, want to play?',
    'home.prompt.text.2': '{name} spotted a butterfly and wants to share!',
    'home.prompt.opt.pat': 'Light pat',
    'home.prompt.opt.hug': 'Pet it',
    'home.prompt.opt.play': 'Play together',
    'home.prompt.opt.ball': 'Throw ball',
    'home.prompt.opt.swing': 'Go swing',
    'home.prompt.opt.water': 'Take a bath',
    'home.prompt.opt.butterfly': 'Chase butterfly',
    'home.prompt.opt.talk': 'Chat a bit',
    'home.prompt.opt.care': 'Pet first',

    // ── Toasts / inline messages ──────────────────────────────────────────
    'home.toast.missionsRefreshed': '🌤 New day — interaction missions refreshed',
    'home.toast.feedEmpty': 'No food in the bag, head to the shop to buy some',
    'home.toast.feedNeedFood': 'No food in bag — reminder to restock',
    'home.toast.activeSwitched': '✨ {name} is now your active pet',
    'home.toast.switchedTo': 'Switched to {name}',
    'home.toast.challengeDone': 'Challenge done! {net} ✨',
    'home.toast.feedEnjoy': '{name}: Thanks! This snack is so yummy! Hunger {hunger} · Happy {happiness}{bonus}',
    'home.toast.feedBonus': ' (species bonus✨)',
    'home.toast.feedThanks': '{name}: Thanks owner, so yummy!',
    'home.toast.feedThankNote': '{name} thanks you for the snack',
    'home.appreciation.feed': '{name} sends you a huge heart: thanks for the snack — I feel so loved!',
    'home.toast.missionReward': 'Reward earned 🤝+{bond} · 💖+{happy} · 📈+{exp}',

    // ── Activity log labels ───────────────────────────────────────────────
    'home.activity.tap': '👋 You patted {name}',
    'home.activity.stroke': '🫶 You stroked {name}, who closed their eyes happily',
    'home.activity.rub': '✨ You and {name} romped for a bit',
    'home.activity.ball': '🎾 {name} chased the ball around',
    'home.activity.swing': '🎠 {name} swayed on the swing',
    'home.activity.water': '🛁 {name} took a bath and twirled happily',
    'home.activity.butterfly': '🦋 A butterfly landed on {name}',
    'home.activity.dialogue': 'Dialogue: {label}',
    'home.activity.startTalk': 'Started a chat with {name}',
    'home.activity.missionDone': 'Mission done: {title}',
    'home.activity.bottleHeard': '{name} heard your whisper',

    // ── Dialogue scene reactions ──────────────────────────────────────────
    'home.dialogue.replyText': '{name}{reply}',
    'home.dialogue.petLine': '{name}: {line}',
    'home.mission.complete': '{name} finished "{title}"',

    // ── Errors ────────────────────────────────────────────────────────────
    'home.error.fallback': 'Something went wrong',
    'home.error.dialogueSync': 'Could not sync dialogue state — refreshed from server',
    'home.error.interactionSync': 'Could not sync interaction state — refreshed from server',
    'home.error.missionClaim': 'Could not claim mission reward, please try again',

    // ── Empty / no-pet state ──────────────────────────────────────────────
    'home.empty.title': 'Your animal park is waiting for its first friend',
    'home.empty.hint': 'Cheapest hamster: 💰15. Do a few quizzes / small tasks to earn some coins first, then adopt your first park buddy!',
    'home.empty.scene.alt': 'Default meadow scene waiting for your pet',
    'home.empty.scene.caption': 'This will grow into your animal park',
    'home.empty.earn.quiz.title': 'Quiz',
    'home.empty.earn.quiz.sub': '💰50 per question',
    'home.empty.earn.chores.title': 'Small tasks',
    'home.empty.earn.chores.sub': 'Daily goals',
    'home.empty.earn.imagine.title': 'Imagine',
    'home.empty.earn.imagine.sub': 'Write stories for rewards',
    'home.empty.earn.shop.title': 'Shop',
    'home.empty.earn.shop.sub': 'Adopt when you have enough',
    'home.empty.goal': '👑 Goal: become the best animal park director',

    // ── Play-gate banner ──────────────────────────────────────────────────
    'home.gate.pending': '⏳ {count} small tasks still need check-in today',
    'home.gate.tail': ' — finish to chat and shop 👉',
    'home.gate.choreWithDeadline': '{title} (by {hour}:00)',

    // ── Pet rail ──────────────────────────────────────────────────────────
    'home.rail.vibe.sad': 'A bit gloomy',
    'home.rail.vibe.hungry': 'Hungry',
    'home.rail.vibe.good': 'Feeling good',
    'home.rail.activeSuffix': ' · active pet',
    'home.rail.manage': 'Manage',
    'home.rail.hiddenCount': '{count} more',
    'home.rail.manageAll': 'All {count}',
    'home.rail.switch': 'Switch pet',
    'home.rail.switch.count': '{count} animals total',
    'home.petDrawer.title': 'Choose a pet',
    'home.petDrawer.subtitle': '{count} animal friends. Care for the ones that need you first.',
    'home.petDrawer.close': 'Close pet chooser',
    'home.petDrawer.filter.all': 'All',
    'home.petDrawer.filter.needs_care': 'Needs care',
    'home.petDrawer.filter.same_species': 'Same species',
    'home.petDrawer.filter.happy': 'Feeling good',
    'home.petDrawer.sort.status': 'By status',
    'home.petDrawer.sort.species': 'By species',
    'home.petDrawer.sort.name': 'By name',
    'home.petDrawer.status.hungry': 'Hungry',
    'home.petDrawer.status.sad': 'Needs company',
    'home.petDrawer.status.happy': 'Great mood',
    'home.petDrawer.status.ok': 'Okay',
    'home.petDrawer.active': 'Active',
    'home.petDrawer.empty': 'No pets match this filter',

    // ── Scene event / dispatch MVP ────────────────────────────────────────
    'home.sceneEvent.action': 'Explore',
    'home.sceneEvent.activity': '{name} finished "{title}"',
    'home.sceneEvent.meadow.title': 'Tiny footprints in the grass!',
    'home.sceneEvent.meadow.desc': '{name} found a trail of tiny footprints and wants you to come too.',
    'home.sceneEvent.meadow.reaction': '{name} followed the footprints and nudged you happily!',
    'home.sceneEvent.meadow.action': 'Explore together',
    'home.sceneEvent.aqua.title': "Something's shining by the water",
    'home.sceneEvent.aqua.desc': '{name} heard water and spotted what looks like a tiny shell.',
    'home.sceneEvent.aqua.reaction': '{name} found a shiny little shell!',
    'home.sceneEvent.aqua.action': 'Take a closer look',
    'home.sceneEvent.aquaFit.title': '{name} wants a walk by the water',
    'home.sceneEvent.aquaFit.desc': '{name} feels extra energetic today and wants to stroll the shore.',
    'home.sceneEvent.aquaFit.reaction': '{name} patrolled the water and looked completely at home!',
    'home.sceneEvent.aquaFit.action': 'Take a stroll with them',
    'home.sceneEvent.blossom.title': 'Petal watch',
    'home.sceneEvent.blossom.desc': '{name} wants to catch a falling petal.',
    'home.sceneEvent.blossom.reaction': '{name} caught a petal and placed it in your hand.',
    'home.sceneEvent.autumn.title': 'Leaf collecting',
    'home.sceneEvent.autumn.desc': '{name} wants to pick the prettiest leaf.',
    'home.sceneEvent.autumn.reaction': '{name} found a beautiful leaf and tucked it away.',
    'home.sceneEvent.night.title': 'Star watch',
    'home.sceneEvent.night.desc': '{name} wants to count the three brightest stars with you.',
    'home.sceneEvent.night.reaction': '{name} counted the stars and quietly leaned closer.',
    'home.sceneEvent.magic.title': 'Mushroom trail',
    'home.sceneEvent.magic.desc': '{name} spotted glowing mushrooms and wants help checking the path.',
    'home.sceneEvent.magic.reaction': "{name} found a sparkling trail and their eyes lit up!",
    'home.sceneEvent.sky.title': 'Cloud patrol',
    'home.sceneEvent.sky.desc': '{name} wants to look for a rainbow at the cloud edge.',
    'home.sceneEvent.sky.reaction': '{name} saw a cloud rainbow and spun with excitement!',
    'home.dispatch.title': 'Pet dispatch',
    'home.dispatch.ready': 'Ready',
    'home.dispatch.remaining': '{seconds}s left',
    'home.dispatch.inProgress': 'In progress',
    'home.dispatch.claim': 'Claim story',
    'home.dispatch.garden.title': 'Garden patrol',
    'home.dispatch.garden.desc': '{name} checks the plants and paths.',
    'home.dispatch.coast.title': 'Coast explore',
    'home.dispatch.coast.desc': '{name} looks for shells and tracks near water.',
    'home.dispatch.library.title': 'Book corner',
    'home.dispatch.library.desc': '{name} learns one new word at the book corner.',
    'home.dispatch.patrol.title': 'Park duty',
    'home.dispatch.patrol.desc': '{name} walks the park to see who needs help.',
    'home.dispatch.toast.started': '{name} started "{title}"',
    'home.dispatch.reaction.start': '{name} packs a tiny bag and starts "{title}"!',
    'home.dispatch.reaction.done': '{name} finished "{title}" and brought back a small story.',
    'home.dispatch.appreciation': '{name} came back from "{title}": I learned something new!',
    'home.dispatch.activity.done': '{name} finished dispatch: {title}',

    // ── Stage / scene picker ──────────────────────────────────────────────
    'home.stage.hint': '🎯 {hint}',
    'home.stage.changeScene': '🖼️ Change scene',
    'home.stage.mode3D': '🧊 3D scene',
    'home.stage.mode2D': '🎨 2D scene',
    'home.stage.noWebgl': "This device doesn't support 3D — switched to 2D scene.",
    'home.stage.challenge.spend': 'spend {cost}',
    'home.stage.challenge.reward': 'reward +{reward}',
    'home.stage.challenge.process': 'Handle',

    // ── Feed FX / labels ──────────────────────────────────────────────────
    'home.feed.fxAria': '{name} is enjoying a snack',
    'home.feed.tasty': 'Yummy!',

    // ── Equipment ─────────────────────────────────────────────────────────
    'home.equipment.title': '{name} (long-press 3s, then drag to place)',

    // ── Scene reaction meta ───────────────────────────────────────────────
    'home.scene.reactionMeta': 'Bond +{bond} · Combo x{combo}',
    'home.scene.replyHint': ' · Tap to chat',
    'home.scene.replyOpening': 'Opening chat…',
    'home.scene.replyAria': 'Reply to pet feedback',

    // ── Scene prompt UI ───────────────────────────────────────────────────
    'home.scenePrompt.later.aria': 'Interact later',
    'home.scenePrompt.later': 'Later',
    'home.scenePrompt.title': '🐾 Interaction invite',
    'home.sceneDialog.close.aria': 'Close dialogue',
    'home.sceneDialog.title': '💬 Chat',
    'home.sceneDialog.chatHint': 'Want to keep talking? Reply in chat.',
    'home.sceneDialog.chatCta': 'Open chat',

    // ── Side panel ────────────────────────────────────────────────────────
    'home.side.actionsTitle': 'Play together',
    'home.action.tap': 'Pat',
    'home.action.stroke': 'Stroke',
    'home.action.rub': 'Romp',
    'home.action.feed': 'Feed',
    'home.action.feed.goBuy': 'Buy food',
    'home.action.feed.bag': 'Bag {count}',
    'home.action.ball': '🎾 Throw ball',
    'home.action.swing': '🎠 Swing',
    'home.action.water': '🛁 Bath',
    'home.action.talk': '💬 Chat',
	    'home.action.bottle': '🍶 Whisper bottle',
	    'home3.action.pet': 'Pet',
	    'home3.action.play': 'Play',
	    'home3.action.chat': 'Chat',
	    'home3.console.aria': "Today's playful plan",
	    'home3.console.kicker': "Today's plan",
	    'home3.console.title': "{name}'s plan for today",
	    'home3.console.titleFallback': "Today's plan",
	    'home3.console.map': 'Open animal park',
	    'home3.playSheet.title': 'How to play?',
	    'home3.playSheet.close': 'Close',

    'home.side.statusTitle': 'Pet status',
    'home.status.noData': 'No mood data yet',
    'home.status.bestBuddy': "We're the best buddies now!",
    'home.status.hungry': "I'm a bit hungry, want a snack",
    'home.status.lonely': 'Hug me, I want to play with you',
    'home.status.elated': "Super happy today, let's keep adventuring",
    'home.status.normal': "Doing fine — a little play would make it even better",
    'home.status.hunger': '🍗 Hunger',
    'home.status.happy': '💖 Happy',
    'home.status.level': '📈 Level',
    'home.status.bond': '🤝 Bond',
    'home.status.bondLevel': 'Lv {level}',

    'home.energy.title': 'Interaction heat',
    'home.energy.hot': 'HOT!',
    'home.energy.combo': 'Combo!',
    'home.energy.start': 'Warming up',
    'home.activity.latest': 'Just now: {text}',

    // ── Right-panel section titles (v0.13.7) ─────────────────────────────
    'home.todayQuest.title': 'Today quest',
    'home.progress.title': 'Progress',

    // ── Mission panel ─────────────────────────────────────────────────────
    'home.mission.panelTitle': "Today's missions",
    'home.mission.badge.ready': '{count} to claim',
    'home.mission.badge.done': '{done}/{total} done',
    'home.mission.reward': 'Reward 🤝{bond} · 💖{happy} · 📈{exp}',
    'home.mission.claim.claiming': 'Claiming...',
    'home.mission.claim.ready': 'Claim',
    'home.mission.claim.done': 'Claimed',
    'home.mission.claim.progress': 'In progress',

    // ── Main hint ─────────────────────────────────────────────────────────
    'home.hint.adopt': 'Head to the shop to adopt your first buddy',
    'home.hint.missionsReady': "{count} mission(s) ready to claim, don't forget",
    'home.hint.starving': '{name} is starving — buy food at the shop',
    'home.hint.lowMood': '{name} is a bit low today — more strokes and ball play will help',
    'home.hint.careerGap': "Next surprise: {unlock}! Almost there — keep playing.",
    'home.hint.noFood': 'No food in your bag — restock at the shop',
    'home.hint.tryDrag': 'Drag-stroke the pet, tap props and butterflies for interactions',

    // ── Pet placeholder name ──────────────────────────────────────────────
    'home.pet.fallbackName': 'Buddy',

    // ── Feed modal ────────────────────────────────────────────────────────
    'home.feed.modalTitle': '🍗 Feed {name}',
    'home.feed.empty': 'No food in your bag~',
    'home.feed.goShop': 'Go to shop',
    'home.feed.qty': 'Qty: {count}',
    'home.feed.do': 'Feed!',
    'home.feed.close': 'Close',

    // ── Scene picker ──────────────────────────────────────────────────────
    'home.scenePicker.title': '🖼️ Change scene',
    'home.scenePicker.hint': 'Only owned scenes are selectable; buy more from Shop → Decor → Scenes',
    'home.scenePicker.meadowAlt': 'Meadow',
    'home.scenePicker.meadowLabel': '🌿 Meadow (default)',
    'home.scenePicker.empty': "You haven't bought any scenes yet.\nCheck Shop → Decor → 🖼️ Scenes~",
    'home.scenePicker.close': 'Close',

    // ── Career rank ───────────────────────────────────────────────────────
    'home.rank.unlock': 'Unlocks: ',
    'home.rank.hamster.state': 'Hamster state: ',
    'home.rank.keeperLevel': 'Keeper Lv.{level}',
    'home.rank.keeperXp': 'Keeper XP: ',
    'home.rank.source.activeDays': 'Active',
    'home.rank.source.careDays': 'Care',
    'home.rank.source.animals': 'Animals',
    'home.rank.source.tasks': 'Tasks',
    'home.rank.next.label': 'Next Lv.{level} {emoji} {title}',
    'home.rank.next.reach': '{money} XP to go',
    'home.rank.next.gap': '{money} XP away from Lv.{level} {title}',
    'home.rank.maxed': 'Max level! The animal park is yours ✨',

    // ── PWA update banner ─────────────────────────────────────────────────
    'home.update.reloading': 'Loading...',

    // ── v0.12.0 Age-tier variants (mirrors zh block; same fallback rules)
    'home.dialogue.tap.0.little': 'Owner pat me! Again!',
    'home.dialogue.tap.0.older':  "Hey, you're back — I was thinking about you!",
    'home.dialogue.tap.0.tween':  "There you are. How's today going?",

    'home.dialogue.stroke.0.little': 'Hug! I love it!',
    'home.dialogue.stroke.0.older':  'Your hand is so gentle, I almost dozed off.',
    'home.dialogue.stroke.0.tween':  'Quiet moments like this hit different.',

    'home.dialogue.rub.0.little': 'Play play play!',
    'home.dialogue.rub.0.older':  "I'm full of energy today — let's go on an adventure!",
    'home.dialogue.rub.0.tween':  "Let's go — gotta bring the chaos today.",

    'home.dialogue.ball.0.little': 'Ball! Throw again!',
    'home.dialogue.ball.0.older':  'Toss it once more — I was super fast just now!',
    'home.dialogue.ball.0.tween':  'Round two? My takeoff was kinda elite.',

    'home.scenePrompt.title.little': '🐾 Play with me!',
    'home.scenePrompt.title.older':  '🐾 Come hang out with me',
    'home.scenePrompt.title.tween':  '🐾 Wanna chat?',

    'home.hint.tryDrag.little': 'Touch me, tap the toys~',
    'home.hint.tryDrag.older':  'Try drag-stroking the pet, tapping props and butterflies for interactions',
    'home.hint.tryDrag.tween':  'Drag-stroke or tap props/butterflies to trigger events',

    'home.hint.starving.little': '{name} is hungry — go find food!',
    'home.hint.starving.older':  "{name} is really hungry, go grab something at the shop",
    'home.hint.starving.tween':  "{name}'s hunger is critical — restock now",

    'home.hint.lowMood.little': '{name} is sad, go pat them!',
    'home.hint.lowMood.older':  '{name} is a bit low — playing together for a bit will help',
    'home.hint.lowMood.tween':  '{name} feels down — a few interactions should reset their mood',
  } as Record<string, string>,
};

export default home;
